exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".add-contact {\n  left: 100px;\n  position: relative;\n}\n\n.para p {\n  margin-bottom: 5px !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/details/contactinformation/contact-information.component.css
// module id = 1950
// module chunks = 0